import i18n from '@translate/i18n';

interface ErrorMap {
    [key: string]: ErrorMessage;
}

interface ErrorMessage {
    zh?: string;
    en?: string;
}

const errorMap: ErrorMap = {
    // 400: {
    //     zh: '未能連接伺服器，請檢查手機數據網絡設定，或稍後再試。 (001)',
    //     en: 'Unable to connect to server, please check data network setting of your device or try again later. (001)',
    // },
    401: {
        zh: '登入逾時，請重新登入。',
        en: 'Login session has expired, please login again.',
    },
    500: {
        zh: '伺服器繁忙/不穩，請稍後再試。 (003)',
        en: 'The server is busy/unstable, please try again later. (003)',
    },
    '502': {
        zh: '伺服器繁忙/不穩，請稍後再試。 (005)',
        en: 'The server is busy/unstable, please try again later. (005)',
    },
    '503': {
        zh: '使用人數超出上限，請稍後再試。 (006)',
        en: 'The number of users exceeds the limit, please try again later. (006)',
    },
    '-999': {
        zh: '伺服器繁忙/不穩，請稍後再試。 (004)',
        en: 'The server is busy/unstable, please try again later. (004)',
    },
    Network: {
        zh: '未能連接伺服器，請檢查手機數據網絡設定，或稍後再試。 (001)',
        en: 'Unable to connect to server, please check data network setting of your device or try again later. (001)',
    },
    'checkEmailValidity-3': {
        zh: '伺服器繁忙/不穩，請稍後再試。 (-3)',
        en: 'The server is busy/unstable, please try again later. (-3)',
    },
};

export const getMessageByCode = (code: string): string => {
    const locale = i18n.language as 'zh' | 'en';
    const errorMessage = errorMap[code];
    if (!errorMessage) return '';
    return errorMessage[locale] || '';
};

export default errorMap;
